import React from 'react';
import { Link } from 'react-router-dom'
import SubHeader from '../../components/Layout/SubHeader';
import { Modal } from 'antd';
import strings from '../../components/Language';
const { confirm } = Modal;
class EditProfileScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lang: strings.getLanguage(),
        }
    }

    async componentDidMount() {
    }

    showConfirm() {
        confirm({
            title: strings["deleteTitle"],
            content: strings["postDeletion"],
            width: 320,
            onOk() {
                localStorage.clear();
                setTimeout(() => {
                    window.location.reload(false);
                }, 100);
            },
            onCancel() {
            },
        });
    };

    _onPressCloseAccount() {
        const self = this;
        localStorage.clear();
        self.timeoutHandle = setTimeout(() => {
            window.location.reload(false);
        }, 100);
    }

    render() {
        return (
            <>
                <SubHeader data={{ title: strings["passwordUpdate"] }} />

                <div className='editProfileScreen'>
                    <main className="menu-container">
                        <Link to={"/mobile-update"} id="mobileUpdate" className="menu-item">
                            {strings["mobileUpdate"]}
                        </Link>
                        <Link to={"/password-update"} id="passwordUpdate" className="menu-item">
                            {strings["passwordUpdate"]}
                        </Link>
                        <Link to={"/referral"} id="referralList" className="menu-item">
                            {strings["referralList"]}
                        </Link>
                        <button onClick={() => this.showConfirm()} id="deleteButton" className="delete-acc">
                            {strings["deleteAccount"]}
                            <span id="deleteText">{strings["deleteText"]}</span>
                        </button>
                    </main>
                </div>

                {/* <div id="deleteModal" className="modal">
                    <div className="modal-container">
                        <h2 id="deleteTitle">Confirm close account?</h2>
                        <p id="postDeletion">
                            We will contact on mobile number and ask for some details to deletion
                            of account. Once everything is confirm, account will be queue for
                            deletion within 30 days.
                        </p>
                        <div className="modal-button">
                            <button className="cancel-button" id="cancelDelete">Cancel</button>
                            <button className="confirm-button" id="confirmDelete">Confirm</button>
                        </div>
                    </div>
                </div> */}
            </>
        );
    }
}

export default EditProfileScreen;
